<template>
  <preavvisi />
</template>

<script>
import Preavvisi from '@/components/ask/pages/Preavvisi.vue'


export default {
  name: 'PreavvisiAll',

  components:{
    Preavvisi
  },

  data(){
    return {
    
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods:{

  },
}
</script>

<style>

</style>
